import React from 'react'

const SubscriptionHeader = () => (
  <header className="stripe-header">
    <h1>Choose Your Preferred Kinstak Plan!</h1>
  </header>
)

export default SubscriptionHeader
